// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useAvailableApprovers = () => {
    const availableApprovers = useAppSelector(state => state.data.accounts.byId["current"]?.availableApprovers);
    return availableApprovers;
};

export default useAvailableApprovers;
